module.exports = __webpack_public_path__ + "img/maps.6fdea74f.png";